import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionPanel,
  Badge,
  BlockUI,
  Button,
  Card,
  Checkbox,
  Column,
  ColumnGroup,
  ConfirmDialog,
  ConfirmPopup,
  DataTable,
  DatePicker,
  Dialog,
  Divider,
  Drawer,
  FloatLabel,
  IconField,
  InputIcon,
  InputNumber,
  InputText,
  Listbox,
  Menu,
  Message,
  Paginator,
  Panel,
  PanelMenu,
  Password,
  PickList,
  Popover,
  ProgressBar,
  ProgressSpinner,
  RadioButton,
  Ripple,
  Row,
  Select,
  SelectButton,
  Splitter,
  SplitterPanel,
  Tab,
  TabList,
  TabMenu,
  TabPanel,
  TabPanels,
  Tabs,
  Tag,
  Textarea,
  Toast,
  ToggleSwitch,
  Tooltip,
  Tree,
  VirtualScroller,
} from 'primevue';
import Chart from 'primevue/chart';

import { AUTOMATION_DIRECTIVE_ATTRIBUTE, AUTOMATION_DIRECTIVE_NAME } from '@/plugins/AutomationPlugin';
import createApp from '@modules/core/app/utils/createApp';
import mapAngularLink from '@modules/core/app/utils/mapAngularLink';
import { vDataTest } from '@modules/core/directives/vDataTest';
import { vDataQaAutoId } from '@modules/core/qa-automation/directives/vDataQaAutoId';
import createSimpleErrorApp from '@modules/error-pages/utils/createSimpleErrorApp';

void mapAngularLink().then((link) => {
  if (link) {
    window.location.href = link;
    return;
  }

  createApp().then((app) => {
    app.component('PButton', Button);
    app.component('PMenu', Menu);
    app.component('PInputText', InputText);
    app.component('PAccordion', Accordion);
    app.component('PAccordionPanel', AccordionPanel);
    app.component('PAccordionHeader', AccordionHeader);
    app.component('PAccordionContent', AccordionContent);
    app.component('PSidebar', Drawer);
    app.component('PProgressSpinner', ProgressSpinner);
    app.component('PPanelMenu', PanelMenu);
    app.component('PCard', Card);
    app.component('PDialog', Dialog);
    app.component('PSplitter', Splitter);
    app.component('PSplitterPanel', SplitterPanel);
    app.component('PListbox', Listbox);
    app.component('POverlayPanel', Popover);
    app.component('PChart', Chart);
    app.component('PToast', Toast);
    app.component('PTree', Tree);
    app.component('PConfirmPopup', ConfirmPopup);

    app.component('PTabMenu', TabMenu);
    app.component('PTabView', Tabs);
    app.component('PTabPanels', TabPanels);
    app.component('PTabPanel', TabPanel);

    app.component('PTabs', Tabs);
    app.component('PTabList', TabList);
    app.component('PTab', Tab);

    app.component('PVirtualScroller', VirtualScroller);
    app.component('PMessage', Message);
    app.component('PBlockUI', BlockUI);
    app.component('PConfirmDialog', ConfirmDialog);
    app.component('PBadge', Badge);
    app.component('PDivider', Divider);
    app.component('PPickList', PickList);
    app.component('PProgressBar', ProgressBar);
    app.component('PTag', Tag);
    app.component('PPanel', Panel);

    // inputs
    app.component('PInputPassword', Password);
    app.component('PInputDropdown', Select);
    app.component('PInputCalendar', DatePicker);
    app.component('PInputCheckbox', Checkbox);
    app.component('PInputSwitch', ToggleSwitch);
    app.component('PInputTextarea', Textarea);
    app.component('PInputNumber', InputNumber);
    app.component('PRadioButton', RadioButton);
    app.component('PSelectButton', SelectButton);

    // table
    app.component('PDataTable', DataTable);
    app.component('PColumn', Column);
    app.component('PColumnGroup', ColumnGroup);
    app.component('PRow', Row);
    app.component('PPaginator', Paginator);
    app.component('PFloatLabel', FloatLabel);
    app.component('PIconField', IconField);
    app.component('PInputIcon', InputIcon);

    app.directive('ripple', Ripple);
    app.directive('tooltip', Tooltip);

    // Testing
    app.directive('dataTest', vDataTest);

    app.directive(AUTOMATION_DIRECTIVE_NAME, vDataQaAutoId({ elemAttrName: AUTOMATION_DIRECTIVE_ATTRIBUTE }));

    app.mount('#app');
  }).catch((error) => {
    console.error(error);

    createSimpleErrorApp();
  });
});
